<template>
  <div id="noData">
    <img :src="imagePath.noData" alt="" />
    <span>{{ title }}</span>
  </div>
</template>

<script>
import imagePath from "@/utils/imagePath";

export default {
  name: "noData",
  props: {
    title: { type: String, default: "暂无学习记录~" }
  },
  data() {
    return {
      imagePath
    };
  }
};
</script>

<style lang="less" scoped>
#noData {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;

  img {
    width: 187px;
    height: 179px;
    object-fit: cover;
  }

  span {
    font-size: 16px;
    color: #666666;
    text-align: center;
  }
}
</style>
